import { CurrencyContext } from "CurrencyProvider";
import Button from "components/base/Button";
import { Input } from "components/base/Form";
import { ButtonWithArrow } from "components/base/base";
import { useContext, useState } from "react";
import { GoHistory } from "react-icons/go";
import { currencySymbol } from "../PriceWithCurrency";
import { productItemsPerSet, productUnitCost } from "../utils";
import ChildProductRow from "./ChildProductRow";
import { ProductCostContext } from "./Detail";

const ProductWithBOM = ({ product, company }) => {
  const { defaultCurrency, showProductWithBomCostHistory } =
    useContext(ProductCostContext);
  const { latestExchangeRate } = useContext(CurrencyContext);
  const [showMore, setShowMore] = useState(false);
  const [calcQty, setCalcQty] = useState(product.defaultQty);
  const itemsPerSet = productItemsPerSet(product);

  const total = productUnitCost(
    product,
    calcQty,
    latestExchangeRate.supplierUsdToRmbRate,
    defaultCurrency,
    company,
  );
  const ltdUntaxedTotal = total / 1.13;
  const letTax = ltdUntaxedTotal * 0.13;

  return (
    <div>
      <table className="mt-4">
        <thead>
          <tr className="bg-gray-100 dark:bg-gray-800 uppercase">
            <th className="uppercase text-left py-3 px-4 border dark:border-gray-700">
              <div className="flex items-center space-x-4">
                <div>Components ( {itemsPerSet} / Set )</div>
                <ButtonWithArrow
                  className="text-sky-600 hover:text-sky-700 active:text-sky-800"
                  show={showMore}
                  onClick={() => setShowMore((prev) => !prev)}
                >
                  Show Calculation
                </ButtonWithArrow>
              </div>
            </th>
            <th className="text-center border dark:border-gray-700 px-4">
              MOQ
            </th>
            <th className="text-center border dark:border-gray-700 px-4">
              Supplier
            </th>
            <th className="text-right border dark:border-gray-700 px-4">Qty</th>
            <th className="text-right border dark:border-gray-700 px-4">
              Price
            </th>
            <th className="text-right border dark:border-gray-700 px-4 whitespace-nowrap">
              Supplier Updated
            </th>
          </tr>
        </thead>
        <tbody>
          {product.children.map((child) => (
            <ChildProductRow
              child={child}
              key={child.id}
              calcQty={calcQty}
              itemsPerSet={itemsPerSet}
              showMore={showMore}
            />
          ))}
        </tbody>
      </table>

      <div className="mt-6">
        <div className="flex items-center space-x-3 justify-between">
          <div>
            <div>
              Product Unit Price for{" "}
              <Input
                className="inline-block mx-1 text-center"
                border="border border-gray-200 dark:border-gray-700"
                validated={calcQty % itemsPerSet === 0}
                value={calcQty}
                onChange={(e) => setCalcQty(e.target.value)}
              />{" "}
              items.
            </div>
            {calcQty % itemsPerSet !== 0 && (
              <div className="text-red-600 dark:text-red-800 mt-1 font-semibold">
                This quantity is not a multiple of the set quantity.
              </div>
            )}
          </div>

          <div className="space-x-3 flex items-center justify-end">
            <Button
              className="ml-4"
              onClick={() => showProductWithBomCostHistory(product.id)}
            >
              <GoHistory size={18} />
            </Button>

            <label>Untaxed:</label>
            <span className="text-base font-code">
              {currencySymbol(defaultCurrency)}{" "}
              {company === "LTD"
                ? ltdUntaxedTotal.toFixed(3)
                : productUnitCost(
                    product,
                    calcQty,
                    latestExchangeRate.supplierUsdToRmbRate,
                    defaultCurrency,
                    company,
                  ).toFixed(3)}
            </span>
          </div>
        </div>

        {company === "LTD" && (
          <div className="flex justify-end">
            <div className="text-right">
              <div className="space-x-3 flex items-center justify-end">
                <label>Tax (13%):</label>
                <span className="text-base font-code">
                  {currencySymbol(defaultCurrency)} {letTax.toFixed(3)}
                </span>
              </div>

              <div>
                <div className="space-x-3 flex items-center justify-end">
                  <label>Total:</label>
                  <span className="text-base font-code">
                    {currencySymbol(defaultCurrency)} {total.toFixed(3)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductWithBOM;
